<div class="tw:flex tw:flex-col tw:lg:flex-row tw:h-auto tw:lg:h-[calc(100vh-64px)]">
  <div class="tw:w-full tw:lg:w-1/2 tw:flex tw:flex-col tw:bg-gray-100 tw:py-8 tw:px-6 tw:overflow-y-auto">
     <div>
      @if (checkoutMode() === CheckoutMode.CREATE_FULL_SALE) {
        <h6 class="tw:h6">{{'INVOICING_PAGE.registerSale' | translate}}</h6>
      } @else {
        <h6 class="tw:h6">{{'INVOICING_PAGE.registerPayment' | translate}}</h6>
      }
     </div>
     <div class="tw:md:px-16 tw:py-8">
         <app-invoice-preview class="tw:w-full" />
     </div>

  </div>
  <div class="tw:w-full tw:lg:w-1/2 tw:flex tw:bg-white tw:overflow-y-auto tw:overflow-x-clip">
    <div class="tw:w-full">
      <router-outlet />
    </div>
  </div>
</div>
